/* eslint 'sort-keys-fix/sort-keys-fix': ['error'] */

// @todo (GROW-4571): ideally, use Codegen to generate an enum of possible
// feature flags names. We'll want to maintain a separate, manual list of flags
// to be requested from the API.
const FEATURE_FLAG_NAMES = [
  'apply_aggressive_buffer_management',
  'archon.ai_subclips',
  'archon.debug',
  'archon.generation',
  'archon.voice',
  'core.guest_seats',
  'labs.web.transformers',
  'v4.3d_asset_support',
  'v4.access_requests',
  'v4.account_settings.search_filters',
  'v4.advanced_search.m2',
  'v4.apps.settings_page',
  'v4.archived_projects',
  'v4.archon',
  'v4.archon.analyze_video',
  'v4.archon.changed_entities',
  'v4.archon.document_generation',
  'v4.archon.document_generation.interactive_html',
  'v4.archon.document_generation.rich_formats',
  'v4.archon.generative_ui',
  'v4.archon_assistant_queries',
  'v4.asset_approvals',
  'v4.audio_waveform',
  'v4.auto_language_detection',
  'v4.brand_abis_validate',
  'v4.brand_ubs_validate',
  'v4.camera_to_cloud_list_view',
  'v4.camera_to_cloud_realtime_logging',
  'v4.captions_upload_timecode_offset',
  'v4.checkout_vat_id_collection',
  'v4.custom_field_groups',
  'v4.delay_matching_children',
  'v4.direct_to_esm',
  'v4.disable_comments_for_all_shares',
  'v4.draggable_project_nav',
  'v4.enhanced_media_contrast',
  'v4.fe.demo-project-cta-ab-test',
  'v4.field_improvements',
  'v4.finder_bulk_edit_metadata',
  'v4.finder_quicklook',
  'v4.firefly_reframe',
  'v4.firefly_rm_bg',
  'v4.firefly_translate',
  'v4.full_page_search',
  'v4.global_navigation',
  'v4.inbox',
  'v4.inbox.reviewer_notifications',
  'v4.include_replies_in_search',
  'v4.increase_finder_pagesize',
  'v4.interactive_live_url',
  'v4.interactive_live_url_auto_sizing',
  'v4.interactive_live_url_enterprise_only',
  'v4.interactive_media_zoom',
  'v4.invites.hide_suggested_members',
  'v4.is_beta',
  'v4.labs',
  'v4.legacy_inbox',
  // Owned by the backend legacy-share conversion work; the FE reads the same
  // flag so the Duplicate-as-V4 action stays in lockstep with the convert path.
  'v4.legacy_share_conversion',
  'v4.link_to_marketing_site',
  'v4.metadata_per_type_field_limits',
  'v4.metadata_select_options_increase',
  'v4.mountable_storage',
  'v4.mounted_storage_awareness',
  'v4.mounted_storage_promo',
  'v4.mounted_storage_suppress_banner',
  'v4.movable-pin',
  'api.mounted_storage_minor_versions',
  'v4.notifications.transfer_batch_completed_self',
  'v4.onboardingTooltips',
  'v4.open_in_creative_cloud',
  'v4.pdf_swipe',
  'v4.quick_search_flyout',
  'v4.quick_search_flyout_m2',
  'v4.quick_search_tabbed_view',
  'v4.quickshare.coverflow',
  'v4.report_abuse',
  'v4.reviewer_approval_sync',
  'v4.route_prefetching_decrease',
  'v4.route_prefetching_increase',
  'v4.search.enable_nlp',
  'v4.send_to_experience_manager',
  'v4.send_to_firefly_video_editor',
  'v4.share_enforce_passphrase_complexity',
  'v4.share_lists',
  'v4.surface_messaging',
  'v4.transcription_speaker_renaming',
  'v4.time_display_settings',
  'v4.undo_redo_metadata_demo',
  'v4.unified_shares_ui',
  'v4.upload_links',
  'v4.uploads_sheet_vapor_list',
  'v4.user_groups',
  'web.account_settings.restrict_data',
  'web.assets.wf_bulk_approvals',
  'web.mux_focus_accounts',
] as const;

// @todo (GROW-4571): derive this type from Codegen and list from server.
export type FeatureFlagName = (typeof FEATURE_FLAG_NAMES)[number];

export const flagNames = FEATURE_FLAG_NAMES.map((f) => f);
